<h2 mat-dialog-title *ngIf="data.action == 'new'">Leave with unsaved changes?</h2>
<h2 mat-dialog-title *ngIf="data.action == 'update'">Are you done updating this {{ data.model }}?</h2>
<mat-dialog-content>
    <p>Click "Search" to continue. Unsaved changes will be lost.</p>    
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close aria-label="cancel search">Stay here</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial aria-label="search">Search</button>
</mat-dialog-actions>